import { useState, useEffect, useMemo, useCallback } from 'react';
import { User, UserFilters } from '../types';

export const useUserFilters = (users: User[]) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchColumn, setSearchColumn] = useState('username');

  const filteredUsers = useMemo(() => {
    if (searchTerm.length < 1) return users;
    
    return users.filter(user => {
      const searchValue = String(user[searchColumn as keyof User] || '').toLowerCase();
      return searchValue.includes(searchTerm.toLowerCase());
    });
  }, [searchTerm, users, searchColumn]);

  const updateFilters = useCallback((newFilters: Partial<UserFilters>) => {
    if (newFilters.searchTerm !== undefined) {
      setSearchTerm(newFilters.searchTerm);
    }
    if (newFilters.searchColumn !== undefined) {
      setSearchColumn(newFilters.searchColumn);
    }
  }, []);

  return {
    searchTerm,
    searchColumn,
    filteredUsers,
    setSearchTerm,
    setSearchColumn,
    updateFilters
  };
};

